import { Input, Component, EventEmitter, Output } from '@angular/core';
import { LinkType } from './link.interface';

@Component({
  selector: 'vm-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
})
export class LinkComponent {
  @Input() type: LinkType = LinkType.STANDALONE;
  @Input() href: string;
  @Input() target: '_blank' | '_self' | '_parent' | '_top' = '_self';
  @Input() routerLink: string | any[];
  @Input() fragment: string;
  @Output() clicked: EventEmitter<any> = new EventEmitter();
  @Input() isExpanded = false;

  public toggle(): void {
    this.isExpanded = !this.isExpanded;
  }
  public onClick(): void {
    this.clicked.emit();
  }
}
